import React from 'react';

import { Card, Skeleton } from 'antd';

import trashCanIcon from 'assets/images/png/trash-can-icon.png';

import './FileCard.less';

interface FileCardProps {
  download: () => void;
  icon: string;
  title: string;
  description?: string | React.ReactElement;
  onDelete?: () => void;
}

function FileCard({
  download,
  icon,
  title,
  description,
  onDelete,
}: FileCardProps): React.ReactElement {
  const fileExtension = title.split('.').pop();

  const titleWithTooltip =
    title.length > 20 ? (
      <span title={title}>{title.slice(0, 20)}...</span>
    ) : (
      title
    );

  const [trashCanVisible, setTrashCanVisible] = React.useState(false);

  function handleDelete(e: React.MouseEvent) {
    e.stopPropagation();
    onDelete && onDelete();
  }

  return (
    <Card
      className="card"
      hoverable
      onClick={download}
      onMouseEnter={() => setTrashCanVisible(!!onDelete)}
      onMouseLeave={() => setTrashCanVisible(false)}
    >
      <Skeleton paragraph={{ rows: 1 }} loading={false} active>
        {trashCanVisible && (
          <div className="trashCanButtonContainer" onClick={handleDelete}>
            <img
              src={trashCanIcon}
              className="trashCanButton"
              alt="Supprimer"
            />
          </div>
        )}
        <Card.Meta
          avatar={
            <img src={icon} style={{ maxHeight: '4em' }} alt={fileExtension} />
          }
          title={titleWithTooltip}
          description={description}
          style={{ overflow: 'visible', whiteSpace: 'unset' }}
        />
      </Skeleton>
    </Card>
  );
}

export default FileCard;
